/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaOptionalFieldsItem } from './ClaimsSchemaOptionalFieldsItem';

export const ClaimsSchemaOptional: core.serialization.ObjectSchema<
    serializers.ClaimsSchemaOptional.Raw,
    Truvity.ClaimsSchemaOptional
> = core.serialization.object({
    fields: core.serialization.list(ClaimsSchemaOptionalFieldsItem).optional(),
    jsonLdBaseIri: core.serialization.property('json_ld_base_iri', core.serialization.string().optional()),
    jsonLdIri: core.serialization.property('json_ld_iri', core.serialization.string().optional()),
    jsonLdRelativeIriDelimiter: core.serialization.property(
        'json_ld_relative_iri_delimiter',
        core.serialization.string().optional(),
    ),
    jsonLdTermName: core.serialization.property('json_ld_term_name', core.serialization.string().optional()),
});

export declare namespace ClaimsSchemaOptional {
    export interface Raw {
        fields?: ClaimsSchemaOptionalFieldsItem.Raw[] | null;
        json_ld_base_iri?: string | null;
        json_ld_iri?: string | null;
        json_ld_relative_iri_delimiter?: string | null;
        json_ld_term_name?: string | null;
    }
}
